<template>
    <ExtrusionInventory></ExtrusionInventory>
</template>

<script>
import { defineAsyncComponent } from "vue";

const AuthLayout = defineAsyncComponent(() =>
    import("../../Layouts/AuthLayout.vue")
);
const ExtrusionInventory = defineAsyncComponent(() =>
    import("../../components/SAW/ExtrusionInventory.vue")
);

export default {
    name: "SAW_ExtrusionInventory", //The name you are in should not equal the name of the component you are importing.
    components: { ExtrusionInventory, AuthLayout },
};
</script>
